import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";
import NavDetails from "components/Elements/NavDetails";
import Icon from "components/Elements/Icon";
import ActionButtonStyle from "styles/application/ActionButtonStyle";
import { AccessTypes } from "helpers/constants";
import { setHistoryDrawerState } from "../../../redux/common/actions";
import { useDispatch } from "react-redux";

const AT = ActionButtonStyle();

const media = "@media (max-width: 414px)";

const useStyles = makeStyles()((theme) => ({
	restore: {
		border: "2px solid",
		borderRadius: "100%",
		height: "35px",
		width: "35px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		color: "#307ad6",
	},
	importButton: {
		background: "#ED8738",
	},
	buttons: {
		display: "flex",
		marginLeft: "auto",
		[media]: {
			marginLeft: "0px",
			flexDirection: "column",
			marginBottom: "10px",
			gap: "10px",
		},
	},
	wrapper: {
		display: "flex",
		[media]: {
			marginTop: "10px",
			justifyContent: "space-between",
			flexDirection: "column",
		},
	},
}));

function Header({ setOpenAddNoticeBoard, dataLength, noticeBoardCC }) {
	// Init hooks
	const { position } = sessionStorage.getItem("me")
		? JSON.parse(sessionStorage.getItem("me"))
		: {};

	const { classes, cx } = useStyles();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	return (
		<div className={"topContainerCustomCaptions"}>
			<NavDetails
				status={false}
				lastSaved={""}
				staticCrumbs={[
					{ id: 1, name: `${noticeBoardCC} (${dataLength})`, url: "" },
				]}
				hideLastLogin
				hideLastSave
				hideVersion={true}
			/>
			<div className={classes.wrapper}>
				{position?.noticeboardAccess &&
					position?.noticeboardAccess !== AccessTypes["Read-Only"] && (
						<div className={classes.buttons}>
							<AT.GeneralButton onClick={() => setOpenAddNoticeBoard(true)}>
								{t("action.addNew")}
							</AT.GeneralButton>
						</div>
					)}
				<div
					className="restore"
					onClick={() => dispatch(setHistoryDrawerState(true))}
				>
					<Icon className={classes.restore} name="Restore" />
				</div>
			</div>
		</div>
	);
}

export default Header;
